import React, { useState } from "react";
import DefaultButton from "../../../../styles/materialButtonStyle";
import WebhookActionsSelect from "../../../../elements/webhookActions/WebhookActionsSelect";
import { TextField } from "@material-ui/core";
import axios from "axios";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import MaterialDialog from "../../../../styles/materialDialog";
import Notification from "../../../../elements/notification/Notification";
import { check2FA } from "../../../../../utils/check2FA";
import getUserInfo from "../../../../../utils/getUserInfo";

import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../../../styles/styledDialog";
import { parseAxiosError } from "../../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../../utils/consts";

const ProjectWebhooksForm = ({ t, projectId, fetchActionList }) => {

  const [checkedWebhookAction, setCheckedWebhookAction] = useState(null);
  const [dataAction, setDataAction] = useState({
    "link": null,
    "twofa": null
  });

  const [open, setOpen] = React.useState(false);
  const [disabled, setDisabled] = useState(false);

  const [error, setError] = React.useState({});

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCreate = async (event) => {
    event.preventDefault();

    setDisabled(true);

    let check2Fa = await check2FA(getUserInfo()["userId"], dataAction.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      setDisabled(false);

      return;
    }

    if (!checkedWebhookAction || !dataAction) {
      setNotification({ ...notification, visible: true, type: "error", message: t("details.webhook.create.errors.checkedWebhookActionMessage") });
      setDisabled(false);

      return;
    }

    let data = {
      url: dataAction.link,
      project: projectId,
      type: checkedWebhookAction
    };

    axios.post("/api/actions", data, userAuthenticationConfig(false)).then(() => {
      setOpen(false);
      fetchActionList();
      setNotification({ ...notification, visible: true, type: "success", message: t("details.webhook.create.success") });
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="projects-webhooks-form">
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("details.webhook.create.form.create")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("details.webhook.create.form.title")}
            </StyledDialogHead>
            <StyledDialogContent>
              <WebhookActionsSelect
                checkedAction={checkedWebhookAction}
                setCheckedAction={setCheckedWebhookAction}
                name="webhook"
              />
              <TextField
                id="url"
                value={dataAction.link}
                onChange={(event) => setDataAction({ ...dataAction, "link": event.target.value })}
                label={t("details.webhook.create.form.link")}
              />
              <TextField
                id="twofa"
                label={t("details.webhook.create.form.twofa")}
                value={dataAction.twofa}
                onChange={(event) => setDataAction({ ...dataAction, "twofa": event.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("details.webhook.create.form.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={handleCreate}
                color="success"
                disabled={disabled}
              >
                {t("details.webhook.create.form.create")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </div>
    </>
  );
};

export default ProjectWebhooksForm;